// --------------------------------------------------------------
// Created On: 2025-09-17
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./DotLoader.module.scss";

// A bouncing dot loading component.
export default function DotLoader(props: Props): Component {
  return props.loading ? (
    <div className={`${styles.dotLoader} ${props.isLarge ? styles.dotLoaderLarge : ""} ${props.className}`}>
      <div />
      <div />
      <div />
      {props.isLarge && <div />}
    </div>
  ) : null;
}

interface Props {
  loading: boolean;
  className: string;
  isLarge?: boolean;
}
